import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CustomMatIconsEnum } from '@lib/enums';

@Injectable({
  providedIn: 'root',
})
export class CustomMatIconService {
  private readonly icons = CustomMatIconsEnum;
  constructor(
    private readonly matIconReg: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {
  }

  /**
   * Promise необходим для использовании в
   * инициализаторе сервиса, в фабрике.
   */
  public initCustomMatIcons(): Promise<any> {
    return new Promise((resolve: any) => {
      this.registerIcons();
      resolve();
    });
  }

  private registerIcons(): void {
    this.loadIcons(Object.values(this.icons), '../assets/icons');
  }

  private loadIcons(iconNames: string[], iconUrl: string): void {
    iconNames.forEach((name: string) => {
      this.matIconReg.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(`${iconUrl}/${name}.svg`));
    });
  }
}
